// extracted by mini-css-extract-plugin
export var bodySections = "_4z-8";
export var gray = "_4z-7";
export var green = "_4z-4";
export var iconContainer = "_4z-9";
export var iconWidgetContainer = "_4z-1";
export var phoneIcon = "_4z-2";
export var red = "_4z-5";
export var statusDot = "_4z-3";
export var widgetContainer = "_4z-0";
export var yellow = "_4z-6";